export default __webpack_public_path__ + "static/media/Croc2.a5312eaf.png";